module.exports = __webpack_public_path__ + "img/twitter.7c818609.svg";